import { useRef, useState, useEffect } from 'react';

const TRUST_ITEMS = [
  { icon: 'ri-medal-line', label: '25+ Years', sub: 'Industrial Expertise' },
  { icon: 'ri-shield-check-line', label: 'ISO-Aligned', sub: 'Certified Processes' },
  { icon: 'ri-tools-fill', label: 'Custom Built', sub: 'Engineered to Spec' },
  { icon: 'ri-flag-line', label: 'American Made', sub: 'MAXJET Systems' },
  { icon: 'ri-customer-service-2-line', label: 'Direct Support', sub: '866-540-7575' },
];

export default function TrustBar() {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold: 0.2 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="relative bg-[#0a0a0a] border-y border-[#1e1e1e] overflow-hidden"
    >
      {/* Gold top accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 py-7">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-1">
          {TRUST_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className={`group relative flex items-center gap-4 px-5 py-4 rounded-lg transition-all duration-500 hover:bg-white/3 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              {idx > 0 && (
                <div className="absolute left-0 top-3 bottom-3 w-px bg-[#1e1e1e] hidden lg:block" />
              )}
              <div className="w-11 h-11 flex items-center justify-center flex-shrink-0 rounded-lg bg-gold/8 border border-gold/15 group-hover:bg-gold/12 transition-colors">
                <i className={`${item.icon} text-gold text-xl`} />
              </div>
              <div>
                <p className="text-white text-sm font-bold font-sans leading-tight">{item.label}</p>
                <p className="text-white/35 text-xs font-sans mt-0.5 whitespace-nowrap">{item.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Gold bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" />
    </section>
  );
}
